<hr class="bottom-bar">
<p class="align-center padding-column-md">
  End of Page
</p>
